// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const PROVIDER_STATUS_VALUES = {
    ACTIVE: "1",
    INACTIVE: "2",
    ACTIVE_AND_INACTIVE: "3",
} as const;

const PROVIDER_STATUS_DESCRIPTIONS = {
    [PROVIDER_STATUS_VALUES.ACTIVE]: "aenInvoiceReport_activeProvider",
    [PROVIDER_STATUS_VALUES.INACTIVE]: "aenInvoiceReport_inactiveProvider",
    [PROVIDER_STATUS_VALUES.ACTIVE_AND_INACTIVE]: "aenInvoiceReport_activeAndInactiveProvider",
} as const;

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { PROVIDER_STATUS_VALUES, PROVIDER_STATUS_DESCRIPTIONS };

// #endregion Exports
